import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {MatRipple} from '@angular/material/core';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../spinner/spinner.component';

@Component({
  selector: 'app-icon-text-button',
  templateUrl: './icon-text-button.component.html',
  styleUrls: ['./icon-text-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRipple, NgClass, SpinnerComponent]
})
export class IconTextButtonComponent {
  @Input() icon: `assets/${string}.svg` | `assets/${string}.png`;
  @Input() color: 'primary' | 'grey' = 'grey';
  @Input() type: 'stroked' | 'default' = 'stroked';
  @Input() size: 'default' | 'compact' = 'compact';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() panelClass = '';
}






